export default function FinalCTA() {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20warm%20toned%20flat%20lay%20collage%20of%20premium%20fashion%20lifestyle%20items%20including%20designer%20sneakers%20structured%20handbags%20soft%20fabric%20textures%20and%20elegant%20accessories%20on%20natural%20linen%20surface%2C%20editorial%20product%20photography%2C%20soft%20golden%20hour%20daylight%2C%20sophisticated%20aesthetic%2C%20rich%20textures%20in%20warm%20earth%20tones%20and%20cream%2C%20no%20text%20or%20logos%20visible%2C%20harmonious%20organic%20composition%20with%20generous%20elegant%20spacing%20between%20objects&width=1440&height=900&seq=cta-bg-final-v2&orientation=landscape"
          alt="Itaobuy spreadsheet system final call to action background with fashion products"
          title="Itaobuy Spreadsheet - Get Started Today"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white tracking-wide">
          GET YOUR SHEET NOW
        </h2>
        <p className="mt-5 text-white/75 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          Join thousands of buyers leveraging the <strong>itaobuy spreadsheet system</strong> to simplify sourcing from China.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-white text-base font-semibold hover:bg-foreground-800 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <span className="flex items-center justify-center w-8 h-8 rounded-full bg-primary-500">
            <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center text-white"></i>
          </span>
          BUY IT NOW
          <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}